import { getAllInstancesByElementName, initialiseComponents } from "../../core";
import Component from "../component.abstract";
import { hw } from "../helpers/paths";
import SuggestInput from "../inputs/autocomplete/autocomplete";

interface BinderAutocompleteprops {
  name: string;
  limit: string;
  neighbor: boolean;
}
export interface AutocompleteField {
    label: string;
    uri: string;
}
interface DirectValues {
  element: Value;
  autocompleteinput: Value;
}

interface Value {
  value: string
}

export default class BinderAutocomplete extends Component {

  private values: any[] = [];
  private suggestInput: SuggestInput;
  private mandatory = false;
  private onValueChange: (valid: boolean) => void = undefined;

  constructor(private props: BinderAutocompleteprops, element: HTMLElement) {
    super(props, element);
  }

  mounted(): void {
    const suggestInputInstances: SuggestInput[] = getAllInstancesByElementName(
      "SuggestInput",
      this.props.name
    );

    for (const instance of suggestInputInstances) {

      this.suggestInput = instance;
      this.mandatory = instance.mandatory;
      if (this.props.neighbor === true) {
        // Check if binder and input have the same parent
        if (this.element.parentNode === instance.getElement().parentNode) {
          PubSub.subscribe("autocomplete-change", (msg:string, instanceSent:SuggestInput) => {
            if(instance.innerInput === instanceSent.innerInput) {
                this.addValueAndUpdate(instance);
                instance.innerInput.value = "";
            }
          })
        } 
      }
        
    }
    
  }

  // Registers a function that will be executed every time
  // the value of this field changes, in order to keep track
  // of the validity of the field
  public setOnChangeCallback(callback: (valid: boolean) => void) {
    this.onValueChange = callback;
  }

  public removeOnChangeCallback(): void {
    this.onValueChange = undefined;
  }

  addValue(instance?: SuggestInput, directValues?: DirectValues): void {
    let value: string;
    let id: string;
    if (instance) {
      value = (<HTMLInputElement>instance.getElement()).value;
      id = instance.autocompleteinput.value;
    } else {
      value = directValues.element.value;
      id = directValues.autocompleteinput.value;
    }

    // Check if a value is selected
    if (!value || !id) {
      return;
    }

    // Check if the value is not already selected
    for (let i = 0; i < this.values.length; i++) {
      if (this.values[i].id === id) {
        return;
      }
    }

    this.values.push({ id: id, value: value });
    const tag = document.createElement("span");
    tag.innerText = value;
    const svgns = "http://www.w3.org/2000/svg";
    const deleteTag = document.createElementNS(svgns, "svg");
    deleteTag.setAttribute("data-controller", "cross-origin-svg");
    deleteTag.setAttribute("data-cross-origin-svg-url-value", hw.getBaseRessourcesUrl() + "/img/svg/close0.svg");
    tag.appendChild(deleteTag);

    this.element.appendChild(tag);
    initialiseComponents();

    const inputText =
      this.element.parentElement.querySelector<HTMLInputElement>(
        "input:not([name])"
      );
    // Add handler on delete icon
    setTimeout(() => {
      const svg = tag.querySelector("svg");
      svg.addEventListener("click", (event) => {
        let index = -1;
        for (let i = 0; i < this.values.length; i++) {
          if (this.values[i].id === id && this.values[i].value === value) {
            index = i;
            break;
          }
        }

        if (index > -1) {
          this.delete(<HTMLElement>event.currentTarget, index);
          if (
            this.element.parentElement.querySelector<HTMLInputElement>(
              "input:not([name])"
            ).disabled === true
          ) {
            inputText.disabled = false;
          }
        }

        const forms = document.querySelectorAll("form");
        if (forms.length) {
          forms[0].dispatchEvent(new Event("change"));
        }
      });
    }, 500);

    const allTags = this.element.querySelectorAll("span:not(.delete-tag)");
    if (this.props.limit && allTags.length === parseInt(this.props.limit)) {
      inputText.disabled = true;
    }
  }

  public addValueAndUpdate(instance?: SuggestInput, directValues?: DirectValues): void {
    this.addValue(instance, directValues);
    this.updateValidity();
  }

  // If the binder has data, disables instance validation
  // Else, force invalidation of the field
  public check(): boolean {
    const valid = this.getValues().length > 0;
    this.suggestInput.forceValidity(valid);
    // Note : this.suggestInput.isValid() <=> this.getValues().length !== 0
    return this.suggestInput.isValid()
  }

  private updateValidity(): void {
    const valid = this.check();
    if(this.onValueChange) {
      this.onValueChange(valid);
    }
  }
  
  getValues(): any[] {
    const result = this.values
      .filter((item, pos) => {
        let index = -1;
        for (let i = 0; i < this.values.length; i++) {
          if (this.values[i].id === item.id) {
            index = i;
            break;
          }
        }

        return index === pos;
      })
      .map((item) => {
        return item.id;
      });

    return result;
  }

  delete(element: HTMLElement, index: number): void {
    this.values.splice(index, 1);
    element.parentElement.remove();
    
    // Check if it was the last value then reacivate mandatory check on instance if needed
    this.updateValidity();
  }

  getValuesAndLabels(): any {
    const result: any = {};

    for (let i = 0; i < this.values.length; i++) {
      result[this.values[i].id] = this.values[i].value;
    }

    return result;
  }

  getCriterionFormatValue(): AutocompleteField[] {
    const result = [];

    for (let i = 0; i < this.values.length; i++) {
      result.push({
        label: this.values[i].value,
        uri: this.values[i].id,
      });
    }

    return result;
  }

  clear(): void {
    this.values = [];
    this.element.innerHTML = "";
  }

}
